export default __webpack_public_path__ + "static/media/CampaignManagement.d4f8f594.svg";